import ChevronRight from './ChevronRight'

export default ChevronRight
// eslint-disable-next-line import/export
export * from './ChevronRight'
